export * from './generated/supported-languages.th';
